import { useQuery } from "@tanstack/react-query";
import taskTypeService from "../api/taskTypeService";

export const useTaskTypeByBoardId = (boardId) => {
  const { getTaskTypeByBoardId } = taskTypeService();

  return useQuery({
    queryKey: ["get-task-types", boardId],
    queryFn: async () => {
      const res = await getTaskTypeByBoardId(boardId);
      return res.data;
    },
    enabled: !!boardId,
  });
};

export const useTaskType = (taskTypeId) => {
  const { getTaskType } = taskTypeService();

  return useQuery({
    queryKey: ["get-task-type", taskTypeId],
    queryFn: async () => {
      const res = await getTaskType(taskTypeId);
      return res.data;
    },
    enabled: !!taskTypeId,
  });
};
